import { render } from "./AgendaItemContextMenu.vue?vue&type=template&id=57bd88a6&scoped=true"
import script from "./AgendaItemContextMenu.vue?vue&type=script&lang=js"
export * from "./AgendaItemContextMenu.vue?vue&type=script&lang=js"

import "./AgendaItemContextMenu.vue?vue&type=style&index=0&id=57bd88a6&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57bd88a6"]])

export default __exports__